import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core'
import { TabComponent } from './tab/tab.component'
import { of, Subject,Observable } from 'rxjs';

@Component({
	selector: 'atyl-tab-group',
	templateUrl: './tab-group.component.html',
	styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent implements OnInit {

	constructor() { }

	@Input() clickTab: Observable<any>;

	@Input() tabDirection: string = 'vertical';
	@ContentChildren(TabComponent) tabs: QueryList<TabComponent>
	@Output() selectedTabChange: EventEmitter<any> = new EventEmitter;
	@Input() dialog: boolean = false;
	@Input() columns: string = '2';
	@Input() default;
	@Input() reduced: boolean = false
	
	ngOnInit() {
		console.log("TabGroupComponent init",this.clickTab)
		//if (this.clickTab!=undefined)
		this.clickTab.subscribe((tab:any) => {
			if (tab!=undefined) {
				             console.log("TabGroupComponent click",tab);
				           //  this.onClickTab(tab)   
						   this.selectTabCode(tab);
				}			 
		});
	}

	ngAfterContentInit(): void {
		// Trouve toutes les tabs activées
		
		
		
		let activeTabs = this.tabs.filter((tab) => tab.active)
		// console.log(this.tabs);
		// S'il n'y a pas de tab activée, active la première
		if (this.default!=undefined) {
			this.selectTabCode(this.default);
		}
		else {
			if (activeTabs.length === 0) {
				this.tabs.first && this.selectTab(this.tabs.first)
			}
		}
	}

	selectTab(tab: any) {
		// Désactive toutes les tabs
		this.tabs.toArray().forEach(tab => tab.active = false)

		// Active la tab cliquée
		tab.active = true
		console.log("TabGroupComponent selectTab",tab)
		this.selectedTabChange.emit(tab)
	}
	
	onClickTab(tb:any) {
		    console.log("TabGroupComponent click",this.tabs.toArray(),tb)
			this.tabs.toArray().forEach((tab,index) => {
			  
				tab.active = false
			    if (tb.index!=undefined && tb.index==index ) {
					console.log("TabGroupComponent clicked",tab)
			        tab.active = true
			        this.selectedTabChange.emit(tab)
			     }
			 })
	}
	
	selectTabCode(tb: any) {
		console.log("TabGroupComponent click",this.tabs.toArray(),tb)
			this.tabs.toArray().forEach((tab, index) => {
				tab.active = false
				if (tb.code != undefined && tb.code == tab.code) {
	                console.log("TabGroupComponent clicked", tb, tab)
					tab.active = true
					this.selectedTabChange.emit(tab)
				}
			})
	}
	
	toggleReduce() {
			this.reduced = !this.reduced
	}

}
